import React from "react";

const TermsOfService = () => (
  <div className="container" style={{ padding: "3rem 0" }}>
    <h1>Terms of Service</h1>
    <p>Last Updated: November 11, 2025</p>
    <p>
      Welcome to Zoteya Beauty Salon! By using our website and purchasing our products or services, you agree to the following terms and conditions.
    </p>
    <h2>Bookings and Orders</h2>
    <ul>
      <li>Bookings are subject to availability and confirmation.</li>
      <li>Product prices and service fees are as shown on the website and are subject to change.</li>
      <li>All hair orders are delivered within 2 weeks from the order date.</li>
      <li>Full payment is required before products are shipped or booked services are confirmed.</li>
    </ul>
    <h2>Refunds & Returns</h2>
    <ul>
      <li>For hygiene and safety, hair products cannot be returned once opened unless defective.</li>
      <li>If you receive a damaged or incorrect item, contact us within 48 hours of delivery.</li>
    </ul>
    <h2>User Conduct</h2>
    <ul>
      <li>Do not misuse this website or transmit harmful or unlawful content.</li>
      <li>Do not infringe on any copyrights or intellectual property on this site.</li>
    </ul>
    <h2>Intellectual Property</h2>
    <p>
      All content on this site, including images, logos, text, and design, is the property of Zoteya Beauty Salon or Webwizards Pty Ltd and may not be copied or reproduced without permission.
    </p>
    <h2>Website Development</h2>
    <p>
      This website was developed by Webwizards Pty Ltd. For web inquiries, reach out to info@webwizards.co.za.
    </p>
    <h2>Contact Us</h2>
    <p>
      For any questions about these terms, contact us at info@zoteya.com.
    </p>
  </div>
);

export default TermsOfService;
